// extracted by mini-css-extract-plugin
module.exports = {"overdueDate":"DashboardUpdatedRecently_overdueDate__4sLfY"};